export const GET_SITE_BRANDING = 'GET_SITE_BRANDING';
export const SET_SITE_BRANDING = 'SET_SITE_BRANDING';
export const UPDATE_SITE_BRANDING = 'UPDATE_SITE_BRANDING';
export const GET_EVENT_BRANDING = 'GET_EVENT_BRANDING';
export const SET_EVENT_BRANDING = 'SET_EVENT_BRANDING';
export const UPDATE_EVENT_BRANDING = 'UPDATE_EVENT_BRANDING';
